import { Section } from '@shared/components/Section';
import { Sanfona } from '@shared/components/moldes';
import { ValorPendente } from '@shared/components/Pendente';
import { RASCUNHO } from '@shared/lib/modo';
import { duvidas } from '@curso/content/duvidas';

/**
 * Bloco 11. Responde: o que ainda trava a decisão.
 *
 * Publicado, pergunta sem resposta não aparece. Uma sanfona que abre em branco
 * frustra mais do que a pergunta ausente.
 */
export function Duvidas() {
  const itens = duvidas
    .filter((duvida) => RASCUNHO || duvida.resposta !== null)
    .map((duvida) => ({
      pergunta: duvida.pergunta,
      resposta: duvida.resposta ?? (
        <ValorPendente>resposta depende de decisão ainda em aberto</ValorPendente>
      ),
    }));

  return (
    <Section id="duvidas" rotulo="Dúvidas" titulo="Perguntas frequentes">
      <Sanfona itens={itens} />
    </Section>
  );
}
